import './card-impact.scss';

export default () => {


};
